import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  createSSO as createSSOService,
  updateSSO as updateSSOService,
  deleteSSO as deleteSSOService, 
  getAllSSO
} from "../../services/tenant/sso.service";
import { validate } from "../../utils";
import { handlerErrorV2 } from "../../utils/errors";
import { updateSSOList, updateSSOListMethod } from "../../store/actions/tenant.actions";
import isEmpty from 'lodash/isEmpty';

const useSSO = () => {
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [errors, setErrors] = useState({});

  const fetchSSO = useCallback(async () => {
    setIsLoadingList(true);
    try {
      const response = await getAllSSO();
      dispatch(updateSSOList(response?.data || []));
    } catch (error) {
      setErrors({ message: error.message || 'An error ocurred'});
    } finally {
      setIsLoadingList(false);
    }
  }, []);

  useEffect(() => {
    fetchSSO();
  }, []);

  const validateForm = (form) => {
    const fieldRules = {
      name: 'required',
      service: 'required',
      clientId: 'required',
    }

    if (form.service === 'cloudwork') {
      fieldRules.issuer = 'required'
    }

    const errors = validate(fieldRules, form)
    if (!isEmpty(errors)) {
      return { error: true, ...errors }
    }

    return { error: false }
  }

  const createSSO = async (form = {}) => {
    const result = validateForm(form);
    if (result.error) {
      return result
    };

    try {
      const response = await createSSOService(form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateSSOListMethod('POST', response.data));
        enqueueSnackbar('SSO created successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const updateSSO = async (yearId, form = {}) => {
    const result = validateForm(form);
    if (result.error) {
      return result
    };

    try {
      const response = await updateSSOService(yearId, form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateSSOListMethod('PUT', response.data));
        enqueueSnackbar('SSO updated successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const deleteSSO = async (yearId) => {
    try {
      const response = await deleteSSOService(yearId);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateSSOListMethod('DELETE', yearId));
        enqueueSnackbar('SSO deleted successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  return {
    errors,
    isLoadingList,
    createSSO,
    updateSSO,
    deleteSSO
  }
};

export default useSSO;